import Button from '../Button';
import { FaDivide } from 'react-icons/fa';
import './Operations.css'; 

const Operations = ({ onClickOperation }) => {
    return(
        <div className="operations" data-testid="operations">
            <div data-testid="operations-item">               
                <Button 
                    text={ (FaDivide && <FaDivide size=".63em"/>) || "/" } 
                    id="divide" 
                    onClickHandler={()=> onClickOperation("/")}
                />
            </div>
            <div data-testid="operations-item">       
                <Button 
                    text="x" 
                    id="multiply" 
                    onClickHandler={()=> onClickOperation("*")}
                    />
            </div>
            <div data-testid="operations-item">                       
                <Button 
                    text="-" 
                    id="subtract" 
                    onClickHandler={()=> onClickOperation("-")}
                    />
            </div>
            <div data-testid="operations-item">                       
                <Button 
                    text="+" 
                    id="add" 
                    onClickHandler={()=> onClickOperation("+")}
                    />
            </div>
        </div>
    );
}

export default Operations;